(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__slideVideoCoverTransitionInit) return;
    window.__slideVideoCoverTransitionInit = true;
    const observerRootMargin = '300px 0px';
    let deferredVideoObserver;

    const markVideoLoaded = (container, video) => {
      if (video.classList.contains('slide__video--desktop')) {
        container.classList.add('is-desktop-video-loaded');
        return;
      }

      if (video.classList.contains('slide__video--mobile')) {
        container.classList.add('is-mobile-video-loaded');
        return;
      }

      container.classList.add('is-video-loaded');
    };

    const hydrateDeferredVideo = (container, deferredContainer) => {
      const template = deferredContainer.querySelector('template[data-video-template]');
      if (!template || !template.content.firstElementChild) return;
      if (deferredContainer.hasAttribute('data-video-mounted')) return;

      const video = template.content.firstElementChild.cloneNode(true);
      const onReady = () => {
        markVideoLoaded(container, video);
        deferredContainer.classList.add('is-video-loaded');
      };

      if (video.readyState >= 2) {
        onReady();
      } else {
        video.addEventListener('loadeddata', onReady, { once: true });
        video.addEventListener('canplay', onReady, { once: true });
        video.addEventListener('loadedmetadata', onReady, { once: true });
        video.addEventListener('playing', onReady, { once: true });
      }

      video.addEventListener(
        'error',
        () => {
          deferredContainer.setAttribute('data-video-error', 'true');
        },
        { once: true }
      );

      deferredContainer.appendChild(video);
      video.preload = 'auto';
      if (typeof video.load === 'function') {
        video.load();
      }

      const tryPlay = () => {
        if (typeof video.play !== 'function') return;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      tryPlay();
      video.addEventListener('canplay', tryPlay, { once: true });
      video.addEventListener('loadedmetadata', tryPlay, { once: true });

      deferredContainer.setAttribute('data-video-mounted', 'true');
    };

    const bindSlideVideoTransitions = (root = document) => {
      const containers = root.querySelectorAll('.slide__image-container');

      containers.forEach((container) => {
        if (container.hasAttribute('data-video-transition-bound')) return;

        const deferredContainers = container.querySelectorAll(
          '[data-deferred-video]:not([data-video-mounted])'
        );

        if (deferredContainers.length) {
          if (typeof IntersectionObserver === 'function') {
            if (!deferredVideoObserver) {
              deferredVideoObserver = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    const deferredContainer = entry.target;
                    deferredVideoObserver.unobserve(deferredContainer);
                    const parentContainer = deferredContainer.closest('.slide__image-container');
                    if (!parentContainer) return;
                    hydrateDeferredVideo(parentContainer, deferredContainer);
                  });
                },
                {
                  root: null,
                  rootMargin: observerRootMargin,
                  threshold: 0.01,
                }
              );
            }

            deferredContainers.forEach((deferredContainer) => {
              deferredVideoObserver.observe(deferredContainer);
            });
          } else {
            deferredContainers.forEach((deferredContainer) => {
              hydrateDeferredVideo(container, deferredContainer);
            });
          }
        }

        if (!container.querySelector('.slide__video-poster')) return;

        const videos = container.querySelectorAll('.slide__video');
        if (!videos.length) return;

        videos.forEach((video) => {
          const onReady = () => markVideoLoaded(container, video);

          if (video.readyState >= 2) {
            onReady();
          } else {
            video.addEventListener('loadeddata', onReady, { once: true });
            video.addEventListener('canplay', onReady, { once: true });
          }
        });

        container.setAttribute('data-video-transition-bound', 'true');
      });
    };

    bindSlideVideoTransitions();
    document.addEventListener('shopify:section:load', () => bindSlideVideoTransitions());
    document.addEventListener('shopify:block:select', () => bindSlideVideoTransitions());
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["go-back"] && !Shopify.designMode) return;
  try {
    if (!window.__goBackBlockBound) {
    window.__goBackBlockBound = true;

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('[data-go-back-link]');
      if (!link) return;

      event.preventDefault();

      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      const fallbackUrl = link.getAttribute('href');
      if (fallbackUrl) {
        window.location.assign(fallbackUrl);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const NUMBER_PATTERN = /-?\d+(\.\d+)?/g;

    const formatInch = (value) => {
      const converted = value / 2.54;
      const rounded = Math.round(converted * 10) / 10;

      if (!Number.isFinite(rounded)) {
        return value.toString();
      }

      if (Number.isInteger(rounded)) {
        return rounded.toString();
      }

      return rounded.toFixed(1).replace(/\.0$/, '');
    };

    const convertCmTextToInch = (cmText) => {
      if (!cmText) {
        return cmText;
      }

      return cmText.replace(NUMBER_PATTERN, (token) => {
        const cmValue = Number.parseFloat(token);

        if (!Number.isFinite(cmValue)) {
          return token;
        }

        return formatInch(cmValue);
      });
    };

    const renderUnit = (switchElement, unit) => {
      const table = switchElement.parentElement?.querySelector('[data-size-guide-table]');

      if (!table) {
        return;
      }

      const isInch = unit == 'inch';
      const toggleButton = switchElement.querySelector('[data-size-guide-unit-toggle]');
      const cells = table.querySelectorAll('[data-size-guide-cell]');

      switchElement.classList.toggle('is-inch', isInch);
      toggleButton?.setAttribute('aria-checked', isInch.toString());

      cells.forEach((cell) => {
        const cmValue = cell.getAttribute('data-cm-value') || cell.textContent?.trim() || '';

        if (isInch) {
          cell.textContent = convertCmTextToInch(cmValue);
          return;
        }

        cell.textContent = cmValue;
      });
    };

    const initUnitSwitch = (switchElement) => {
      if (switchElement.dataset.sizeGuideUnitSwitchInitialized == 'true') {
        return;
      }

      const toggleButton = switchElement.querySelector('[data-size-guide-unit-toggle]');

      switchElement.dataset.sizeGuideUnitSwitchInitialized = 'true';
      switchElement.dataset.currentUnit = 'cm';

      renderUnit(switchElement, 'cm');

      toggleButton?.addEventListener('click', () => {
        const currentUnit = switchElement.dataset.currentUnit == 'inch' ? 'inch' : 'cm';
        const nextUnit = currentUnit == 'cm' ? 'inch' : 'cm';

        switchElement.dataset.currentUnit = nextUnit;
        renderUnit(switchElement, nextUnit);
      });
    };

    const initAllUnitSwitches = (root = document) => {
      root.querySelectorAll('[data-size-guide-unit-switch]').forEach(initUnitSwitch);
    };

    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllUnitSwitches());
    } else {
      initAllUnitSwitches();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        initAllUnitSwitches(event.target);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
